var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inviteregis-container"},[_c('div',{staticClass:"form-container"},[_c('van-button',{staticClass:"register-btn",on:{"click":_vm.handleDownload}},[_vm._v("点击下载APP")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }